import bannerImage from "../../assets/images/category-banners/sport-clothing.png";

export default {
  h1Text: `Спортивная одежда с логотипом на заказ online`,
  h2Text: ``,
  regularTextHtml: `
    <div>
        Мы всё чаще выбираем удобство и комфорт в одежде, носим кеды и кроссовки. Уличный стиль не приемлет строгих правил и рамок. Выбор одежды всё чаще продиктован спортивным образом жизни. Элементы спортивной одежды встречаются уже повсеместно. В Принтио вы сможете добавить индивидуальности в ваш образ. Нанести принт на одежду очень просто с помощью нашего редактора. Добавьте надпись, нажмите кнопку заказать и ждите вашу уникальную вещь!
    </div>`,
  buttonText: `Выбрать предмет`,
  image: [bannerImage],
};
